/**
 * These are the layer type constants that are used in the Config to determine which OpenLayers layer type
 * to instantiate
 */
export enum ConfigLayerType {
  GEOJSON = 'GeoJSON',
  MAPBOX = 'Mapbox',
  MAPBOX_GL = 'Mapbox-GL',
  MAPBOX_OLMS = 'Mapbox-OLMS',
  QGIS_PROJECT_SETTINGS = 'QGISProjectSettings',
  IMAGE_WMS = 'ImageWMS',
  TILE_WMS = 'TileWMS',
  WMTS = 'WMTS',
  WFS_GET_CAPABILITIES = 'WFSGetCapabilities',
  WMS_GET_CAPABILITIES = 'WMSGetCapabilities',
  WMTS_CAPABILITIES = 'WMTSCapabilities'
}
